module.exports = __webpack_public_path__ + "2e90bf536663780900660b54b9136cd6.jpg";